import type { EventResource } from "@/graphql.ts";
import type { CategorizedResources } from "@/ui-modules/playbooks/events/PlaybookEventResources.tsx";

export const filterEventResources = (filter: string, eventResources: EventResource[]) => {
  if (!filter) {
    return eventResources;
  }

  return eventResources.filter((resource) => {
    return (
      resource.file?.humanReadablePath?.toLowerCase().includes(filter) ||
      resource.file?.description?.toLowerCase().includes(filter) ||
      resource.folder?.humanReadablePath?.toLowerCase().includes(filter) ||
      resource.organism?.name?.toLowerCase().includes(filter) ||
      resource.resourceType?.toLowerCase().includes(filter)
    );
  });
};

export const filterCategorizedResources = (filter: string, categorizedResources: CategorizedResources[]) => {
  if (!filter) {
    return categorizedResources;
  }

  return categorizedResources
    .map((categorizedResource: CategorizedResources) => {
      if (categorizedResource.category?.toLowerCase().includes(filter)) {
        return categorizedResource;
      }
      const matchingResources = filterEventResources(filter, categorizedResource.resources);
      if (matchingResources.length) {
        return { ...categorizedResource, resources: matchingResources };
      }
      return null;
    })
    .filter((eventInput) => eventInput != null);
};
